import React, { useEffect } from "react";
import "../Css/YouthEmpowerment.css";

const gains = [
  {
    icon: "🏓",
    title: "Coaching Skills",
    desc: "Training includes fundamentals of table tennis — forehand, backhand, serves, receive techniques, footwork patterns, topspin and backspin control, blocking, looping, pushing, and basic rally strategies.",
  },
  {
    icon: "🧠",
    title: "Leadership Development",
    desc: "Athletes learn communication, teamwork, and community-engagement skills that prepare them to lead programs with confidence.",
  },
  {
    icon: "🤝",
    title: "Service Experience",
    desc: "Youth volunteers support Parkinson's sessions, workshops, and outreach events, gaining meaningful hands-on service experience.",
  },
  {
    icon: "🌱",
    title: "Personal Growth",
    desc: "The program builds purpose, empathy, and a deeper understanding of health equity and community wellness.",
  },
];

const chapters = [
  { location: "Seattle, WA" },
  { location: "Tri-Valley, CA" },
  { location: "Los Angeles, CA" },
  { location: "San Jose, CA" },
  { location: "Fremont, CA" },
  { location: "Phoenix, AZ" },
];

const YouthEmpowerment = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Youth Empowerment | SportsForEquity";

    let metaDescription = document.querySelector('meta[name="description"]');
    let createdMeta = false;
    const prevDescription = metaDescription ? metaDescription.getAttribute("content") : null;

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
      createdMeta = true;
    }
    metaDescription.setAttribute(
      "content",
      "SportsForEquity trains youth athletes to become confident leaders through table tennis, building coaching skills, leadership, and community service experience across our national chapters."
    );

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        metaDescription.remove();
      } else if (prevDescription !== null) {
        metaDescription.setAttribute("content", prevDescription);
      }
    };
  }, []);

  return (
    <div className="ye-page">

      {/* Hero */}
      <div className="ye-hero">
        <div className="ye-hero-icon">🏅</div>
        <h1 className="ye-hero-title">Youth Empowerment</h1>
        <p className="ye-hero-tagline">
          Empowering the next generation of young athletes through table tennis —
          building discipline, focus, confidence, and leadership skills that carry
          far beyond the table.
        </p>
      </div>

      {/* About Our Program */}
      <div className="ye-section">
        <h2 className="ye-section-heading">About Our Program</h2>
        <p className="ye-body">
          SportsForEquity provides ongoing training and leadership development for youth athletes.
          Our program helps young athletes build the skills, confidence, and purpose needed to lead
          movement-based wellness initiatives in their own communities.
        </p>
        <p className="ye-body">
          Youth leaders receive structured guidance, hands-on practice, and opportunities to support
          real community programs — including Parkinson's sessions, workshops, outreach events, and
          wellness activities. Through this training, athletes learn how to coach safely, communicate
          effectively, and serve with empathy.
        </p>
        <p className="ye-body">
          For training schedules or to express interest in joining, please contact us at{" "}
          <a className="ye-contact-link" href="mailto:info@sportsforequity.live">
            info@sportsforequity.live
          </a>
          .
        </p>
      </div>

      {/* Chapters & Programs */}
      <div className="ye-section">
        <h2 className="ye-section-heading">🏅 Youth Empowerment — Chapters &amp; Programs</h2>
        <div className="ye-chapters-grid">
          <div className="ye-chapter-group">
            <h4 className="ye-group-label ye-group-label--ongoing">Ongoing</h4>
            {chapters.map((c, i) => (
              <div key={i} className="ye-chapter-card ye-chapter-card--ongoing">
                <span className="ye-chapter-dot ye-chapter-dot--ongoing"></span>
                <span className="ye-chapter-location">{c.location}</span>
                <span className="ye-chapter-badge ye-chapter-badge--ongoing">Ongoing</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* What Youth Athletes Gain */}
      <div className="ye-section">
        <h2 className="ye-section-heading">What Youth Athletes Gain</h2>
        <div className="ye-gains-grid">
          {gains.map((g, i) => (
            <div className="ye-gain-card" key={i}>
              <div className="ye-gain-icon">{g.icon}</div>
              <h3 className="ye-gain-title">{g.title}</h3>
              <p className="ye-gain-desc">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default YouthEmpowerment;